"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = void 0;
/**
 * @fileOverview Cross
 */

var Cell = exports.Cell = function Cell(_props) {
  return null;
};
Cell.displayName = 'Cell';